import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'; // 完整引入element-ui
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/mixins.scss'; // 引入全局样式
import '@/utils/directives';//引入自定义指令
import SlideVerify from 'vue-monoplasty-slide-verify'


import VueVideoPlayer from "vue-video-player/src";
import "vue-video-player/src/custom-theme.css";

Vue.use(VueVideoPlayer)
Vue.use(SlideVerify)
// 全局混入
import index from '@/mixins/index'
Vue.mixin(index)
Vue.config.productionTip = false;

Vue.use(ElementUI); // 完整引入element-ui

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


